import { formatLocalDateForTimeline } from '@/utils/date'
import { TimelineFilterValue } from '../types'
import { FUTURE_DATE_LIMIT, PAST_DATE_LIMIT } from './constants'

export const isValidTimelineFilterValue = (
    filterValue: TimelineFilterValue
) => {
    if (filterValue.type === 'is') {
        return true
    }

    if (['isBefore', 'isBetween'].includes(filterValue.type)) {
        return (
            filterValue.value.endDate !==
            formatLocalDateForTimeline(FUTURE_DATE_LIMIT)
        )
    }

    return (
        filterValue.value.startDate !==
        formatLocalDateForTimeline(PAST_DATE_LIMIT)
    )
}
